var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkillIconsGmailLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_1210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8438 0H5.15625C2.30853 0 0 2.30853 0 5.15625V16.8438C0 19.6915 2.30853 22 5.15625 22H16.8438C19.6915 22 22 19.6915 22 16.8438V5.15625C22 2.30853 19.6915 0 16.8438 0Z",
    fill: "#F4F2ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57809 17.4487H6.31245V10.808L2.40625 7.87842V16.2768C2.40625 16.9252 2.93167 17.4487 3.57809 17.4487Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6875 17.4488H18.4219C19.0703 17.4488 19.5938 16.9233 19.5938 16.2769V7.87842L15.6875 10.8081",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6875 5.72995V10.8081L19.5938 7.87847V6.31578C19.5938 4.86662 17.9395 4.04042 16.7813 4.90959",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3125 10.8082V5.73015L11 9.2456L15.6874 5.72998V10.8081L11 14.3238",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.40625 6.31578V7.8783L6.31245 10.808V5.72995L5.21873 4.90959C4.05857 4.04042 2.40625 4.86662 2.40625 6.31578Z",
    fill: "#C5221F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_1210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillIconsGmailLight);
export default __webpack_public_path__ + "static/media/skill-icons_gmail-light.e783a36b0b929d12d205fb9bcfa58bfd.svg";
export { ForwardRef as ReactComponent };